"use client";
import { Icon } from "@iconify/react";

const CustomIconifyIcon = ({ name, className }: any) => {
  return <Icon icon={name} className={className} />;
};

export default CustomIconifyIcon;
